// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__z47KD","file":"styles_file__1Luni"};